import { useEffect, useState } from "react";
// Custom React Hook to manage and retrieve application configurations
export const useConfigurations = () => {
    // Local state to store the configurations
    const [dataConfigurations, setDataConfigurations] = useState([]);
    useEffect(() => {
        // If configurations are already available globally, use them directly
        if (window.dataConfigurations) {
            setDataConfigurations(window.dataConfigurations);
            return;
        }
        // Otherwise, fetch configurations from the backend
        const apiUrl = process.env.REACT_APP_API_URL; // Base API URL from environment variables
        const url = new URL(`/configurations`, apiUrl); // Build full endpoint URL
        // Fetch the configuration data
        fetch(url.toString())
            .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json(); // Parse the JSON response
        })
            .then(data => {
            setDataConfigurations(data); // Save configurations to local state
            window.dataConfigurations = data; // Optionally expose them globally
        })
            .catch(error => {
            // Log any errors during the fetch process
            console.error('There was a problem with the fetch operation:', error);
        });
    }, []); // Run this effect only once on component mount
    // Function to retrieve a specific configuration value by key and cast it to type T
    function getConfiguration(key) {
        var _a;
        return (_a = dataConfigurations.find((config) => config.key === key)) === null || _a === void 0 ? void 0 : _a.value;
    }
    // Return the function for accessing configuration values
    return {
        getConfiguration
    };
};
